import {User} from "../../core/user/user.types";

export interface UserState {
    connectedUser:User,
    isPartnerAdmin:boolean,
    isMandataire:boolean,
    isAcepPartner:boolean,
    userPartner:any,
    userCustomer:any,
    userPreferences: { [code: string]: string } | null // null = pas encore chargées
}

export const initialUserState: UserState = {
    connectedUser: null,
    isPartnerAdmin:false,
    isMandataire:false,
    isAcepPartner:false,
    userPartner:null,
    userCustomer:null,
    userPreferences: null,
};